import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'

export enum ApplicantTypeEnum {
    PRINCIPAL = 'principal',
    COAPPLICANT = 'coapplicant',
}

export function getCreditScoreDisclosureUri(
    applicationId: number,
    applicantType: ApplicantTypeEnum,
) {
    const targetLetterId = 'risk-based-pricing-disclosure'
    const encodedApplicationId = encodeURIComponent(applicationId)
    const encodedApplicantType = encodeURIComponent(applicantType)
    const encodedTargetLetterId = encodeURIComponent(targetLetterId)

    // eslint-disable-next-line max-len
    return `/api/v3/applications/${encodedApplicationId}/letters/${encodedTargetLetterId}/?applicant_type=${encodedApplicantType}`
}

export default async function getCreditScoreDisclosure(
    applicationId: number,
    applicantType: ApplicantTypeEnum,
    abortController: AbortController,
) {
    const url = `${
        config.API_BASE_URL +
        getCreditScoreDisclosureUri(applicationId, applicantType)
    }`

    try {
        if (!applicationId || !applicantType) {
            throw new Error(
                `Invalid applicationId (${applicationId}) or applicantType (${applicantType})`,
            )
        }

        const { data } = await axios.get(url, {
            signal: abortController.signal,
            withCredentials: true,
        })

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Unable to generate PDF data for credit score disclosure: ${axiosError.message}`,
            axiosError,
            { applicationId, applicantType },
        )

        throw axiosError
    }
}
